let data = [
  {
    id: 1,
    name: 'Creative Agency',
    description: 'A software company based website where you can order service , give review and admins can manage.',
    image: 'https://i.ibb.co/5W32yvq/Screenshot-320.png',
    github: 'https://github.com/reya3183/creative-agency.git',
    website:'https://creative-agency-c5e02.web.app/'
  },
  {
    id: 2,
    name: 'Volunteer Network',
    description: 'A Website for volunteers where you can choose multiple social activities,delete and admin can manage.',
    image: 'https://i.ibb.co/qktdcGM/Screenshot-319.png',
    github: 'https://github.com/reya3183/volunteer-network.git',
    website:'https://volunteer-547ac.web.app/'
  },
  {
    id: 3,
    name: 'Travel Guru',
    description: 'A travel company based website where you can selected your location and website shows you some hotels with Google Maps.',
    image: 'https://i.ibb.co/MPc1gF2/Screenshot-322.png',
    github: 'https://github.com/reya3183/travel-guru.git',
    website:'https://travel-guru-6dce5.web.app/'
  },
  {
    id: 4,
    name: 'Online Courses',
    description: 'An interactive front-end designed with react-bootstrap where a student can choose multiple courses.',
    image: 'https://i.ibb.co/HDMzbJg/Screenshot-321.png',
    github: 'https://github.com/reya3183/online-courses.git',
    website:'https://confident-lamport-4ee81c.netlify.app/'
  },
  {
    id: 5,
    name: 'Ema-John',
    description: 'A e-commerce site where you can order product , remove from your cart and pay online using your credit card.',
    image: 'https://i.ibb.co/vVCqn20/Screenshot-323.png',
    github: 'https://github.com/reya3183/ema-jhon-simple.git',
    website:'https://ema-jhon-simple-e75ee.web.app/'
  }
]
export default data;